export const TABS = {
  viewAll: 'View All',
  expired: 'Expired',
  expiringSoon: 'Expiring Soon',
  pending: 'Pending',
  inProgress: 'In Progress',
  archive: 'Archive',
  draft: 'Draft'
};

export const TABLE_HEADERS = {
  productName: 'Product name',
  barcode: 'Barcode',
  certificationNumber: 'Certification number',
  countryOfOrigin: 'Country of origin',
  managedBy: 'Managed by',
  expiration: 'Expiration',
  approvalDate: 'Approval date',
  maintenanceDate: 'Maintenance date',
  nextMaintenanceDate: 'Next maintenance date',
  archiveReason: 'Archive reason',
  attachments: 'Attachments',
  comments: 'Comments',
  description: 'Description',
  modelName: 'Model name',
  productClass: 'Product class',
  productType: 'Product type',
  accreditedBy: 'Accredited by',
  brandName: 'Brand name',
  manufacturer: 'Manufacturer',
  certificationURL: 'Certification URL',
  status: 'Status',
  productCategory: 'Product category',
  standards: 'Standards',
  ordinance: 'Ordinance',
  importedProduct: 'Imported Product',
  importer: 'Importer',
  requester: 'Requester',
  tradeRepresentative: 'Trade Representative',
  inputStatus: 'Input Status',
  testReport: 'Test Report',
  testReportAttachments: 'Test Report Attachments',
  productCertificate: 'Product Certificate',
  productCertificateAttachments: 'Product Certificate Attachments',
  barcodeFile: 'Barcode File',
  barcodeAttachments: 'Barcode Attachments'
};
